module.exports = __webpack_public_path__ + "img/interlude_btn2.9b09472b.png";